import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useIntl } from '@atlassian/jira-intl';
import type { resolutionGroupHeader_issueTableGrouping$key } from '@atlassian/jira-relay/src/__generated__/resolutionGroupHeader_issueTableGrouping.graphql';
import { TextGroupHeaderContent } from '../../../../common/text-group-header-content/index.tsx';
import messages from './messages.tsx';

export type Props = {
	resolutionGroupHeader: resolutionGroupHeader_issueTableGrouping$key | null;
};

export const ResolutionGroupHeader = ({ resolutionGroupHeader }: Props) => {
	const data = useFragment<resolutionGroupHeader_issueTableGrouping$key>(
		graphql`
			fragment resolutionGroupHeader_issueTableGrouping on JiraJqlResolutionFieldValue {
				displayName
				resolution {
					id
					name
				}
			}
		`,
		resolutionGroupHeader,
	);

	const { formatMessage } = useIntl();

	return (
		<TextGroupHeaderContent
			text={data?.displayName || data?.resolution?.name || data?.resolution?.id}
			noValueText={formatMessage(messages.noResolution)}
		/>
	);
};
